export default function sanitizeUserId (id) {
  return id.replace('auth0|', '').trim()
}